<template>
	<div id="TreeListView">
		<ListView :items="treeItems" @selected="selected" :showIndex="true" :selectKeyboardListeners="selectKeyboardListeners"></ListView>
	</div>
</template>


<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import ListView from '../../components/ListView';

	@Component({
		components: {
			ListView
		},
	})

	export default class TreeListView {
		@Prop(Array) items;
		@Prop(Array) selectKeyboardListeners;

		selected(...args) {
			this.$emit('selected', ...args);
		}

		get treeItems() {
			return this.items;
		}
	}
</script>

<style lang="scss">
	#TreeListView {
		max-height: 100%;
		display: flex;
		flex-direction: column;
	}
</style>
